import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { orders_image } from '../../Image/Index';
import {
	getGiftCardOrder,
	getMerchantWallet,
	sendEmail,
	Token_Generator,
	regenerate,
	giftCardOrder,
	updateOrderList,
	getGiftCardLists,
} from '../../actions/auth';
import { getDate } from '../../utils/helper';
import Header from '../layout/Header';
import { decrypt } from '../../utils/encodingdecoding';
import { Tab, Tabs } from 'react-bootstrap';
import Page from '../admin/Page';
import swal from 'sweetalert';
import { useDispatch } from 'react-redux';

const ResellerOrders = () => {
	const [loader, setLoader] = useState(true);
	const [merchantdata, setMerchantdata] = useState([]);
	const [orderList, setOrderList] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [currentPage1, setCurrentPage1] = useState(0);
	const pageSize = 10;
	const pageSize1 = 5;
	const pageCount = Math.ceil(merchantdata?.length / pageSize);
	const pageCount1 = Math.ceil(orderList?.length / pageSize1);
	const dispatch = useDispatch();

	const getWallet = async () => {
		const token = JSON.parse(localStorage.getItem('token_gen'));
		const merchantCode = localStorage.getItem('merchantcode');
		const merchant = await getMerchantWallet(
			token?.access_token,
			decrypt(merchantCode),
		);
		await getOrderList();
		setMerchantdata(merchant?.data?.queryforHistoryData);
		setLoader(false);
	};

	const getOrderList = async () => {
		const token = JSON.parse(localStorage.getItem('token_gen'));
		const response = await getGiftCardOrder(token.access_token);
		const groupedData = response?.message?.data.reduce((acc, item) => {
			const refNo = item.refNo;
			if (!acc[refNo]) {
				acc[refNo] = [];
			}
			acc[refNo].push(item);
			return acc;
		}, {});

		const result = Object.keys(groupedData).map((refNo) => ({
			refNo,
			items: groupedData[refNo],
		}));
		setOrderList(result);
	};

	useEffect(() => {
		getWallet();
	}, []);

	const handleEmail = async (vendor_id, refNo) => {
		setLoader(true);
		const regenerateRes = await regenerate(refNo, vendor_id);
		const tokenRes = await Token_Generator();
		const token = JSON.parse(localStorage.getItem('token_gen'));
		let giftcards = [];

		if (regenerateRes?.data?.data?.vendor_name === 'Razorpay GC') {
			let tempProName;
			orderList?.map((order) => {
				if (order.refNo === refNo) {
					tempProName = order?.items[0]?.giftcardName;
				}
			});
			regenerateRes.data.data.data.attributes.gift_card_orders.forEach(
				(order) => {
					order.attributes.vouchers.forEach((vou) => {
						const temp = {
							productName: tempProName,
							cardNo: vou.card_number,
							pin: vou.pin,
							amount: vou.denomination,
						};
						giftcards.push(temp);
					});
				},
			);

			let updateStatus = [];
			orderList?.map((ele) => {
				if (ele.refNo === refNo) {
					regenerateRes.data.data.data.attributes.gift_card_orders.forEach(
						(order) => {
							ele.items.map((item) => {
								if (
									item.price == order.attributes.denomination
								) {
									const tempUpdateStatus = {
										status:
											order.attributes.status ===
											'complete'
												? 'success'
												: order.attributes.status ===
												  'partial_success'
												? 'pending'
												: order.attributes.status,
										price: item.price,
										refNo: refNo,
									};
									updateStatus.push(tempUpdateStatus);
								}
							});
						},
					);
				}
			});
			if (updateStatus?.length > 0) {
				const res = await updateOrderList(
					token.access_token,
					updateStatus,
				);
				getOrderList();
			}
		} else {
			if (regenerateRes.vendor_name === 'QwikSilver') {
				regenerateRes?.cards?.forEach((order) => {
					const temp = {
						productName: order.productName,
						cardNo: order.cardNumber,
						pin: order.cardPin,
						amount: order.amount,
					};
					giftcards.push(temp);
				});

				let body = [];
				orderList?.map((ele) => {
					if (ele.refNo === refNo) {
						const tempBody = {
							status:
								regenerateRes.status === 'COMPLETE'
									? 'success'
									: regenerateRes.status.toLowerCase(),
							price: regenerateRes?.cards[0]?.amount,
							refNo: refNo,
						};
						body.push(tempBody);
					}
				});
				if (body?.length > 0) {
					const updateListRes = await updateOrderList(
						token.access_token,
						body,
					);
					getOrderList();
				}
			} else {
				//swal
			}
		}

		const tableRows = giftcards
			.map(
				(card) => `
                <tr>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.productName || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.cardNo || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.pin || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.amount
					}</td>
                </tr>
            `,
			)
			.join('');

		const tempEmail = {
			subject: 'Purchased giftcard list',
			sendgridApiKey:
				'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',
			fromEmail: 'support@loyalty.novusloyalty.com',
			fromName: 'Novus Loyalty',
			emails: [
				{
					email: decrypt(localStorage.getItem('email')),
					name: decrypt(localStorage.getItem('name')),
				},
			],
			body:
				giftcards?.length > 0
					? `<!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <title>Gift card list</title>
                    </head>
                    <body style="margin: 0;">
                        <p>Please find the purchased giftcard list below:</p>
                        <table width="580" border="0" cellspacing="0" cellpadding="0" align="center" bgcolor="#ffffff" style="margin: 0 auto; width: 580px; background: #fff;">
                            <thead>
                                <tr>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Product Name</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Card No</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Pin</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                    </body>
                    </html>`
					: `<!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <title>Gift card list</title>
                    </head>
                    <body style="margin: 0;">
                        <p>Giftcard not found for this reference number</p>
                    </body>
                    </html>`,
			purpose: '',
			fileName: '',
		};
		const emailRes = await sendEmail(tokenRes.access_token, tempEmail);
		if (emailRes.message === 'Sending Email SuccessFull') {
			swal({
				position: 'center',
				icon: giftcards?.length > 0 ? 'success' : 'error',
				title:
					giftcards?.length > 0
						? `Purchased Giftcard List sent to ${decrypt(
								localStorage.getItem('email'),
						  )}`
						: 'Giftcard not found for this reference number',
				showConfirmButton: false,
				timer: 5000,
			});
			setLoader(false);
		} else {
			swal({
				position: 'center',
				icon: 'error',
				title: 'Something went wrong please try later',
				showConfirmButton: false,
				timer: 5000,
			});
			setLoader(false);
		}
		setLoader(false);
	};

	// const handleExport = async (vendor_id, refNo) => {
	//     console.info({refNo})
	//     const regenerateRes = await regenerate(refNo, vendor_id);
	//     const token = JSON.parse(localStorage.getItem("token_gen"));
	//     const data = [["Product Name", "Card No", "Pin", "Amount"]];
	//     if (regenerateRes?.data?.data?.vendor_name === "Razorpay GC") {
	//         let tempProName;
	//         orderList?.map((order) => {
	//             if (order.refNo === refNo) {
	//                 tempProName = order?.items[0]?.giftcardName;
	//             }
	//         });
	//         regenerateRes?.data?.data.data.attributes.gift_card_orders.forEach((order) => {
	//             order.attributes.vouchers.forEach((vou) => {
	//                 const rowData = [tempProName, vou.card_number, vou.pin, vou.denomination];
	//                 data.push(rowData);
	//             });
	//         });

	//         let updateStatus = [];
	//         orderList?.map((ele) => {
	//             if (ele.refNo === refNo) {
	//                 regenerateRes.data.data.data.attributes.gift_card_orders.forEach((order) => {
	//                     ele.items.map((item) => {
	//                         if (item.price == order.attributes.denomination) {
	//                             const tempUpdateStatus = {
	//                                 status: order.attributes.status === "complete" ? "success" : order.attributes.status === "partial_success" ? "pending" : order.attributes.status,
	//                                 price: item.price,
	//                                 refNo: refNo,
	//                             };
	//                             updateStatus.push(tempUpdateStatus);
	//                         }
	//                     });
	//                 });
	//             }
	//         });
	//         if (updateStatus?.length > 0) {
	//             const res = await updateOrderList(token.access_token, updateStatus);
	//             getOrderList();
	//         }
	//     } else {
	//         if (regenerateRes.vendor_name === "QwikSilver") {
	//             regenerateRes?.cards?.forEach((order) => {
	//                 const rowData = [order.productName, order.card_number, order.pin, order.denomination];
	//                 data.push(rowData);
	//             });

	//             let body = [];
	//             orderList?.map((ele) => {
	//                 if (ele.refNo === refNo) {
	//                     const tempBody = {
	//                         status: regenerateRes.status === "COMPLETE" ? "success" : regenerateRes.status.toLowerCase(),
	//                         price: regenerateRes?.cards[0]?.amount,
	//                         refNo: refNo,
	//                     };
	//                     body.push(tempBody);
	//                 }
	//             });
	//             if (body?.length > 0) {
	//                 const updateListRes = await updateOrderList(token.access_token, body);
	//                 console.log(updateListRes);
	//                 getOrderList();
	//             }
	//         } else {
	//             //swal
	//         }
	//     }

	//     const csvContent = "data:text/csv;charset=utf-8," + data.map((row) => row.join(",")).join("\n");
	//     const encodedUri = encodeURI(csvContent);
	//     const link = document.createElement("a");
	//     link.setAttribute("href", encodedUri);
	//     link.setAttribute("download", "giftcard.csv");
	//     document.body.appendChild(link);
	//     link.click();
	// };

	const handleExport = async (orderId) => {
		setLoader(true);
		try {
			/* ----------------------------------
		   Fetch Order Details
		----------------------------------- */
			const orderData = await dispatch(
				getGiftCardLists({ code: orderId }),
			);

			if (!orderData?.item_list?.length) return;

			/* ----------------------------------
		   CSV Header
		----------------------------------- */
			const data = [['Product Name', 'Card Number', 'Card Pin']];

			/* ----------------------------------
		   Iterate item_list → cards
		----------------------------------- */
			orderData.item_list.forEach((item) => {
				const cards = item?.vendor_order_response?.cards || [];

				cards.forEach((card) => {
					data.push([
						card?.productName || item?.name || '',
						card?.cardNumber || '',
						card?.cardPin || '',
					]);
				});
			});

			/* ----------------------------------
		   Generate CSV
		----------------------------------- */
			const csvContent =
				'data:text/csv;charset=utf-8,' +
				data.map((row) => row.join(',')).join('\n');

			const encodedUri = encodeURI(csvContent);
			const link = document.createElement('a');

			link.setAttribute('href', encodedUri);
			link.setAttribute('download', 'giftcards.csv');

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			setLoader(false);
		} catch (err) {
			setLoader(false);

			console.error('Export failed', err);
		}
	};

	return (
		<>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='reseller_home'>
				<Header name='Home' />
				<div className='reseller_home__body'>
					<div className='dashboard__customerViewCard'>
						<div className='dashboard__customerViewPointsTabs reseller_tabs'>
							<Tabs id='customerViewPointsTabs'>
								<Tab
									Tab
									eventKey='My Orders'
									title='My Orders'>
									<div className='table-responsive'>
										<table className='table table-striped table-bordered'>
											<thead>
												<tr>
													<th>Ref No</th>
													<th>Order ID</th>
													<th>Product name</th>
													<th>Order value</th>
													<th>Discount</th>
													<th>Discounted Value</th>
													<th>Date</th>
													<th>Status</th>
													<th>Export</th>
													{/* <th>Email/Export</th> */}
												</tr>
											</thead>
											{
												<tbody>
													{orderList &&
													orderList.length > 0 ? (
														orderList
															.sort((a, b) => {
																const aDiff =
																	Math.abs(
																		new Date(
																			a.createdAt,
																		) -
																			new Date(),
																	);
																const bDiff =
																	Math.abs(
																		new Date(
																			b.createdAt,
																		) -
																			new Date(),
																	);
																return (
																	aDiff -
																	bDiff
																);
															})
															.slice(
																currentPage1 *
																	pageSize1,
																(currentPage1 +
																	1) *
																	pageSize1,
															)
															.map((list, i) => (
																<React.Fragment
																	key={i}>
																	{list?.items?.map(
																		(
																			ele,
																			ind,
																		) => (
																			<tr
																				key={`${i}-${ind}`}>
																				{ind ===
																					0 && (
																					<td
																						rowSpan={
																							list
																								.items
																								.length
																						}>
																						{
																							list.refNo
																						}
																					</td>
																				)}
																				<td>
																					{
																						ele.order_id
																					}
																				</td>
																				<td>
																					{
																						ele?.giftcardName
																					}
																				</td>
																				<td>
																					{ele?.price *
																						(ele?.quantity ||
																							1)}
																				</td>
																				<td>
																					{ele?.discount
																						? `${ele?.discount} %`
																						: '-'}
																				</td>
																				<td>
																					{
																						ele?.discountedvalue
																					}
																				</td>
																				<td>
																					{getDate(
																						ele?.createDatetime,
																						'DD-MM-YYYY',
																					)}
																				</td>
																				<td>
																					{
																						ele?.status
																					}
																				</td>
																				{ind ===
																					0 && (
																					<td
																						rowSpan={
																							list
																								.items
																								.length
																						}>
																						<div
																							className='email_export_box'
																							style={{
																								cursor: 'pointer',
																							}}>
																							{/* <i class="fa fa-envelope" aria-hidden="true" onClick={() => handleEmail(ele.vendor_id, ele.refNo)}></i>  */}
																							<i
																								class='fa fa-download'
																								aria-hidden='true'
																								onClick={() =>
																									// handleExport(
																									// 	ele.refNo,
																									// 	ele.vendor_id,
																									// )
																									handleExport(
																										ele.refNo,
																									)
																								}></i>
																						</div>
																					</td>
																				)}
																			</tr>
																		),
																	)}
																</React.Fragment>
															))
													) : (
														<tr>
															<td colSpan={9}>
																<div className='reseller_no_orders_box'>
																	<div className='reseller_no_orders_boxed'>
																		<img
																			src={
																				orders_image
																			}
																			alt='fig'
																			style={{
																				maxWidth:
																					'20%',
																			}}
																		/>
																		<h4>
																			You
																			haven't
																			made
																			any
																			orders
																			yet
																		</h4>
																		<p>
																			Please
																			head
																			over
																			to
																			the{' '}
																			<strong>
																				Brand
																				Gift
																				Voucher
																			</strong>{' '}
																			store
																			to{' '}
																			<br />
																			buy
																			your
																			favourite
																			brand
																			vouchers
																			at
																			attractive
																			discounts.
																		</p>
																		<Link to='/reseller-home'>
																			Homepage
																		</Link>
																	</div>
																</div>
															</td>
														</tr>
													)}
												</tbody>
											}
										</table>
									</div>

									{orderList && orderList?.length > 0 && (
										<div>
											<div className='dashboard__paginationBox'>
												<Page
													currentPage={currentPage1}
													setCurrentPage={
														setCurrentPage1
													}
													pageCount={pageCount1}
													value={5}
												/>
											</div>
										</div>
									)}
								</Tab>
								<Tab
									eventKey='Finance Summary'
									title='Finance Summary'>
									<div className='table-responsive'>
										<table className='table table-striped table-bordered finance_summary_table'>
											<thead>
												<tr>
													<th>Point</th>
													<th>Amount (&#8377;)</th>
													<th>Date</th>
													<th>Merchant ID</th>
													<th>Type</th>
													<th>Status</th>
													<th>Description</th>
												</tr>
											</thead>
											{
												<tbody>
													{merchantdata &&
													merchantdata.length > 0 ? (
														merchantdata
															.sort((a, b) => {
																const aDiff =
																	Math.abs(
																		new Date(
																			a.createdAt,
																		) -
																			new Date(),
																	);
																const bDiff =
																	Math.abs(
																		new Date(
																			b.createdAt,
																		) -
																			new Date(),
																	);
																return (
																	aDiff -
																	bDiff
																);
															})
															.slice(
																currentPage *
																	pageSize,
																(currentPage +
																	1) *
																	pageSize,
															)
															.map(
																(
																	statement,
																	i,
																) => (
																	<tr key={i}>
																		<td>
																			{
																				statement?.value
																			}
																		</td>
																		<td>
																			{statement?.value /
																				4}
																		</td>
																		<td>
																			{getDate(
																				statement?.createdAt,
																				'DD-MM-YYYY',
																			)}
																		</td>

																		<td>
																			{
																				statement?.merchantCode
																			}
																		</td>
																		<td>
																			{statement?.operationType ===
																			'Deduct'
																				? 'Debit'
																				: statement?.operationType ===
																				  'Redeem'
																				? 'Debit'
																				: statement?.operationType ===
																				  'Refund'
																				? 'Credit'
																				: statement?.operationType}
																		</td>
																		<td>
																			{statement?.operationType ===
																			'Deduct'
																				? 'Debit'
																				: statement?.operationType ===
																				  'Debit'
																				? 'Redeem'
																				: statement?.operationType}
																		</td>
																		<td>
																			<div className=''>
																				{
																					statement?.description
																				}
																			</div>
																		</td>
																	</tr>
																),
															)
													) : (
														<tr>
															<td colSpan='5'>
																<h6 className='text-center'>
																	No Record
																	Found
																</h6>
															</td>
														</tr>
													)}
												</tbody>
											}
										</table>
									</div>

									{merchantdata &&
										merchantdata?.length > 10 && (
											<div>
												<div className='dashboard__paginationBox'>
													<Page
														currentPage={
															currentPage
														}
														setCurrentPage={
															setCurrentPage
														}
														pageCount={pageCount}
														value={5}
													/>
												</div>
											</div>
										)}
								</Tab>
							</Tabs>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ResellerOrders;
